 "use client";

import SingleSwiper from "@/swiper/SingleSwiper";
import { EPageName } from "@/util/enum";
import ProjectDetailsCard, { ProjectDetailsCardProps } from "./ProjectDetailsCard";

export type GoogleReviewsCarouselProps = {
    items: ProjectDetailsCardProps[];
    preloadFirstProject?: boolean;
};

const ProjectDetailsSwiper = ({
  items,
  preloadFirstProject = false,
}: GoogleReviewsCarouselProps) => (
  <SingleSwiper
    pageName={EPageName.FOURSLIDE}
    crouselData={items}
    slideDelayTime={2000}
    autoHeight={false}
    loop={true}
    slideClassName="h-auto! self-stretch"
    renderItem={({ id, ...item }: ProjectDetailsCardProps, index: number) => (
      <ProjectDetailsCard
        key={id}
        {...item}
        imgPriority={preloadFirstProject && index === 0}
      />
    )}
  />
);

export default ProjectDetailsSwiper;
